import React from "react";
import { Link } from "react-router-dom";
import LOGO from "../assets/logo.png";
function TopNav() {
  return (
    <nav className="w-full bg-white h-16 flex items-center px-4 py-2 fixed top-0 z-50">
      <Link to={"/"}>
        <img src={LOGO} alt="FASE" className=" w-10 h-10 object-center object-contain" />
      </Link>
      <Link to={"/"}>
        <h2 className="font-bold ml-4">FASE</h2>
      </Link>
      <div className="flex-grow flex justify-center"></div>
      <Link to={"/rules"} className="mr-4">
        <p className="animate hover:underline hover:text-purple-600 hover:font-semibold">Rules</p>
      </Link>
      <Link to={"/about"}>
        <p className="animate hover:underline hover:text-purple-600 hover:font-semibold">About</p>
      </Link>
    </nav>
  );
}

export default TopNav;
